import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Logo } from '../assets/images';
import { supportLink } from '../consts';

export default function TopNav() {
  return (
    <nav className="bg-white shadow">
      <div className="mx-auto px-2 sm:px-4 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex px-2 lg:px-0">
            <div className="flex-shrink-0 flex items-center mx-6">
              <img src={Logo} alt="Credit Key Logo" />
            </div>
          </div>
          <div className="ml-4 flex items-center">
            <a
              href={supportLink}
              className="text-primary-blue hover:text-navy-blue"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={['far', 'circle-question']}
                className="px-2 md:px-4 shrink-0 min-w-[24px] cursor-pointer text-xl"
              />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
